import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const Benefits3DIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_i_3982_59690)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M16.8008 7.20005C17.7949 7.20005 18.6008 8.00594 18.6008 9.00005C18.6008 9.99416 17.7949 10.8 16.8008 10.8H14.2924C12.1257 10.8 11.3339 10.953 10.5191 11.3887C9.85503 11.7439 9.34461 12.2543 8.98944 12.9184C8.62073 13.6078 8.45452 14.2808 8.41211 15.7842L8.40078 16.6917V31.3084C8.40078 33.4751 8.55369 34.2669 8.98944 35.0817C9.34461 35.7458 9.85503 36.2562 10.5191 36.6114C11.2086 36.9801 11.8815 37.1463 13.385 37.1887L14.2924 37.2001H33.7091C35.8758 37.2001 36.6676 37.0471 37.4824 36.6114C38.1465 36.2562 38.657 35.7458 39.0121 35.0817C39.4479 34.2669 39.6008 33.4751 39.6008 31.3084V16.6917C39.6008 14.525 39.4479 13.7332 39.0121 12.9184C38.657 12.2543 38.1465 11.7439 37.4824 11.3887C36.6676 10.953 35.8758 10.8 33.7091 10.8H31.2008C30.2067 10.8 29.4008 9.99416 29.4008 9.00005C29.4008 8.00594 30.2067 7.20005 31.2008 7.20005L34.3111 7.20479C36.6278 7.24316 37.8808 7.51928 39.1802 8.21418C40.4717 8.90486 41.496 9.92917 42.1866 11.2206C42.9395 12.6283 43.2008 13.9815 43.2008 16.6917L43.196 31.9104C43.1577 34.2271 42.8815 35.4801 42.1866 36.7795C41.496 38.0709 40.4717 39.0952 39.1802 39.7859C37.7726 40.5387 36.4193 40.8 33.7091 40.8H14.2924C11.5822 40.8 10.229 40.5387 8.82137 39.7859C7.52991 39.0952 6.5056 38.0709 5.81492 36.7795C5.06211 35.3718 4.80078 34.0186 4.80078 31.3084V16.6917C4.80078 13.9815 5.06211 12.6283 5.81492 11.2206C6.5056 9.92917 7.52991 8.90486 8.82137 8.21418C10.229 7.46137 11.5822 7.20005 14.2924 7.20005H16.8008ZM27.6008 26.4C28.5949 26.4 29.4008 27.2059 29.4008 28.2001C29.4008 29.1942 28.5949 30 27.6008 30H15.0008C14.0067 30 13.2008 29.1942 13.2008 28.2001C13.2008 27.2059 14.0067 26.4 15.0008 26.4H27.6008ZM33.0008 19.2C33.9949 19.2 34.8008 20.0059 34.8008 21C34.8008 21.9942 33.9949 22.8 33.0008 22.8H15.0008C14.0067 22.8 13.2008 21.9942 13.2008 21C13.2008 20.0059 14.0067 19.2 15.0008 19.2H33.0008ZM24.0523 4.80005C24.4461 4.80005 24.7485 4.87245 25.0027 5.00841C25.2569 5.14437 25.4565 5.34389 25.5924 5.59811C25.7284 5.85233 25.8008 6.15477 25.8008 6.54852V11.4516C25.8008 11.8453 25.7284 12.1478 25.5924 12.402C25.4565 12.6562 25.2569 12.8557 25.0027 12.9917C24.7485 13.1276 24.4461 13.2 24.0523 13.2H23.9492C23.5555 13.2 23.2531 13.1276 22.9988 12.9917C22.7446 12.8557 22.5451 12.6562 22.4091 12.402C22.2732 12.1478 22.2008 11.8453 22.2008 11.4516V6.54852C22.2008 6.15477 22.2732 5.85233 22.4091 5.59811C22.5451 5.34389 22.7446 5.14437 22.9988 5.00841C23.2531 4.87245 23.5555 4.80005 23.9492 4.80005H24.0523Z",
                fill: color
            })
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsxs("filter", {
                id: "filter0_i_3982_59690",
                x: "3.80078",
                y: "4.80005",
                width: "39.4004",
                height: "37",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ jsx("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "BackgroundImageFix",
                        result: "shape"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ jsx("feOffset", {
                        dx: "-1",
                        dy: "1"
                    }),
                    /*#__PURE__*/ jsx("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ jsx("feComposite", {
                        in2: "hardAlpha",
                        operator: "arithmetic",
                        k2: "-1",
                        k3: "1"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in2: "shape",
                        result: "effect1_innerShadow_3982_59690"
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { Benefits3DIcon };
